var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "document-item" }, [
    _c(
      "td",
      { staticClass: "pa-1" },
      [
        _c("v-icon", { attrs: { large: "", color: "primary" } }, [
          _vm._v("insert_drive_file")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "pa-1" },
      [
        _c(
          "a",
          {
            staticStyle: { "text-decoration": "none" },
            attrs: { href: _vm.source.link, target: "_blank" }
          },
          [
            _c(
              "strong",
              {
                staticClass: "primary--text",
                staticStyle: { "font-size": "100%" },
                attrs: { for: "" }
              },
              [_vm._v(_vm._s(_vm.source.name))]
            )
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "primary--text",
            staticStyle: { "font-weight": "300" }
          },
          [
            _vm._v(
              "Mí en ligne le " +
                _vm._s(_vm.getCreatedDate(_vm.source.createdAt))
            )
          ]
        ),
        _vm._v(" "),
        _c("v-spacer")
      ],
      1
    ),
    _vm._v(" "),
    _c("td", { staticClass: "pa-1" }, [
      _c(
        "button",
        {
          staticClass: "delete-button",
          attrs: { type: "button" },
          on: { click: _vm.handleDelete }
        },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v("delete_outline")
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05aabebe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05aabebe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-documents/components/block-document-item/template.html
// module id = null
// module chunks = 